import './product-anchors.scss';
import anchors from './utils/anchors';

anchors();
